import { render, staticRenderFns } from "./KategoriAnggota.vue?vue&type=template&id=2ee8fbce&"
import script from "./KategoriAnggota.vue?vue&type=script&lang=js&"
export * from "./KategoriAnggota.vue?vue&type=script&lang=js&"
import style0 from "./KategoriAnggota.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports